export default class FAQ {

	constructor() {

		this.settings = {
			$accordion : $('.faq-accordion ')
		};

		this.bindUIActions();

	}

	bindUIActions() {

		if(this.settings.$accordion.length) {
			let i;
			for (i = 0; i < this.settings.$accordion.length; i++) {
				this.settings.$accordion[i].addEventListener("click", function() {
					this.classList.toggle("active");
					var panel = this.nextElementSibling;
					if (panel.style.maxHeight) {
						panel.style.maxHeight = null;
					} else {
						panel.style.maxHeight = panel.scrollHeight + "px";
					}
				});
			}

		}

	}

};

new FAQ();
